/* eslint-disable react-hooks/exhaustive-deps */
import { CopyOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, message, Modal, Row, Select, Table, Tooltip } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerDevicesApi } from '../../api/customerApi';
import { getLogServicesApi } from '../../api/LogServiceApi';
import { DECODED_ACCESS_TOKEN, NAMESPACE, NOTIFIES } from '../../constants/system.keys';
import * as ACTIONS from '../../redux/actions';
import storageService from '../../services/storage.service';
import EventTimeline from '../EventTimeline/EventTimeline';
import PlayerServiceComponent from '../PlayerService';
import './index.scss';
import LogEventLineChart from './LogEventLineChart';

const PAGE_SIZE = 10;
const SECURITY_INDENTIFICATION = 15;
const WARNING_ZONE = 29;
const CAMERA_SUMMARY = 26;
const OPEN_STREAM = 21;

const { RangePicker } = DatePicker;

const startDate = 105;
const endDate = 1394;

const LogEventServiceCamera = ({ dataDevice, baseUrl, serviceId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [current, setCurrent] = useState(1);
  const [dataPageSize, setDataPageSize] = useState(PAGE_SIZE);
  const [visible, setVisible] = useState(false);
  const [dataRangerGateway, setDataRangerGateway] = useState([
    moment().startOf('day').valueOf(),
    moment().endOf('day').valueOf(),
  ]);
  const [dataFilterType, setDataFilterType] = useState(
    'camera_disconnection_session'
  );
  const [dataLogServiceCamera, setdataLogServiceCamera] = useState({});
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [dataColumn, setDataColumn] = useState([]);
  const [chartPeriodMs, setChartPeriodMs] = useState(
    moment.duration(1, 'hour').asMilliseconds()
  );
  const chartRef = useRef(null);
  const timelineRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataDetail, setDataDetail] = useState();
  const { namespace } = useSelector((state) => state);


  const [temporaryDate, setTemporaryDate] = useState({ startDate, endDate });

  useEffect(() => {
    if (dataDevice) {
      setIsLoading(true);
      onFilterLog(dataDevice?.serial, dataFilterType);
    }
  }, []);

  const handleCancel = () => {
    setIsModalVisible(false);
    setDataDetail(undefined);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onFilterLog = async (serial, type, fromTime, toTime, limit, offset) => {
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const dataQuery = {
      serial,
      fromTime: fromTime
        ? Math.floor(fromTime / 1000)
        : serviceId === OPEN_STREAM
          ? 0
          : Math.floor(moment().startOf('day').valueOf() / 1000),
      toTime: toTime
        ? Math.floor(toTime / 1000)
        : Math.floor(moment().endOf('day').valueOf() / 1000),
      limit: limit ?? PAGE_SIZE,
      offset: offset ?? 0,
      isDownload: 0,
      customerNamespace: namespace,
    };
    const dataRes = await getLogServicesApi(
      baseUrl,
      token,
      { namespace },
      dataQuery
    );
    if (dataRes?.data?.records) {
      const dataMapTemp = Object.keys(dataRes?.data?.records?.[0] ?? {});
      const dataColumnTemp = (
        dataMapTemp.includes('streamUrl') ? ['streamUrl'] : dataMapTemp
      )?.map((item) => ({
        title: <span style={{ textTransform: 'capitalize' }}>{item}</span>,
        dataIndex: item,
        key: item,
        render: (text, dataItemDetail) => {
          if (text && `${text}`?.includes('.mp4')) {
            return (
              <div className="streaming-video" style={{ width: '190px' }}>
                <PlayerServiceComponent
                  type="video"
                  src={text}
                />
              </div>
            );
          } else if (
            text &&
            (`${text}`?.includes('.jpg') ||
              `${text}`?.includes('.jpeg') ||
              `${text}`?.includes('.png'))
          ) {
            return (
              <img
                style={{ width: '190px' }}
                alt="img"
                src={text}
                onClick={() => {
                  dispatch(
                    ACTIONS.popupVideoStorageFileByTimeReturn({
                      dataDetail: {
                        extraInfo: JSON.stringify({
                          timestamp: dataItemDetail?.timestamp,
                          serial: dataItemDetail?.serial,
                        }),
                        content: dataItemDetail?.objects,
                      },
                      isModalVisible: true,
                    })
                  );
                }}
              />
            );
          } else if (text && item.includes('streamUrl')) {
            return (
              <Row>
                <Col>
                  <p
                    style={{
                      textAlign: 'center',
                      margin: 0,
                      lineHeight: '32px',
                    }}
                  >
                    {text}
                  </p>
                </Col>
                <Col>
                  <Button
                    style={{ borderColor: 'transparent', marginLeft: '4px' }}
                    icon={<CopyOutlined />}
                    onClick={() => {
                      navigator.clipboard
                        .writeText(text)
                        .then(() => {
                          ACTIONS.openMessage(
                            NOTIFIES.SUCCESS,
                            'Sao chép thành công!'
                          );
                        })
                        .catch((err) => {
                          ACTIONS.openMessage(
                            NOTIFIES.WARNING,
                            'Sao chép thất bại!'
                          );
                          console.error('Lỗi khi sao chép:', err);
                        });
                    }}
                  ></Button>
                </Col>
              </Row>
            );
          } else {
            return text;
          }
        },
      }));
      setDataColumn(dataColumnTemp);
      setdataLogServiceCamera(dataRes?.data ?? {});
    }
    setIsLoading(false);
  };

  const onDownloadLog = async (
    serial,
    type,
    fromTime,
    toTime,
    limit,
    offset
  ) => {
    const token = storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
    const dataQuery = {
      serial,
      fromTime: fromTime ?? moment('01-01-2019', 'DD-MM-YYYY').valueOf(),
      toTime: toTime ?? moment().valueOf(),
      limit: limit ?? PAGE_SIZE,
      offset: offset ?? 0,
      isDownload: 1,
      type,
    };
    const dataRes = await getCustomerDevicesApi(
      token,
      { namespace },
      dataQuery
    );
    setTimeout(() => {
      if (dataRes?.data) {
        const buttonElement = document.createElement('a');
        buttonElement.href = `data:text/csv;charset=utf-8,${encodeURI(
          dataRes.data
        )}`;
        buttonElement.target = '_blank';
        buttonElement.download = `report-log.${moment(fromTime).format(
          'DD_MM_YYYY'
        )}-${moment(toTime).format('DD_MM_YYYY')}.csv`;
        buttonElement.click();
      } else {
        ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
      }
      setIsLoadingExport(false);
    }, 800);
  };

  const onPageChange = (newPage, pageSize) => {
    console.log('call api1');

    setCurrent(newPage);
    setDataPageSize(pageSize);
    setIsLoading(true);
    onFilterLog(
      dataDevice?.serial,
      dataFilterType,
      dataRangerGateway[0],
      dataRangerGateway[1],
      pageSize,
      (newPage - 1) * dataPageSize
    );
  };

  const handleDateRangerChange = (values) => {
    console.log('call api');

    const FromDate =
      values.length > 0
        ? values[0].set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        : '';
    const ToDate =
      values.length > 0
        ? values[1].set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
        : '';
    if (ToDate.diff(FromDate, 'days') > 7) {
      message.warning(t('Please choose within 7 days'));
      return;
    }
    setCurrent(1);
    setDataPageSize(PAGE_SIZE);
    setIsLoading(true);
    setDataRangerGateway([
      moment(FromDate).valueOf(),
      moment(ToDate).valueOf(),
    ]);
    console.log('call api1');

    onFilterLog(
      dataDevice?.serial,
      dataFilterType,
      moment(FromDate).valueOf(),
      moment(ToDate).valueOf(),
      PAGE_SIZE,
      0
    );
  };

  const handleSelectType = (value) => {
    setCurrent(1);
    setDataPageSize(PAGE_SIZE);
    setIsLoading(true);
    setDataFilterType(value);
    onFilterLog(
      dataDevice?.serial,
      value,
      dataRangerGateway[0],
      dataRangerGateway[1],
      PAGE_SIZE,
      0
    );
  };

  const handleRefresh = () => {
    if (chartRef.current) chartRef.current.refreshChartData();
    if (timelineRef.current) timelineRef.current.refreshTimelineData();
    onPageChange(current, dataPageSize);
  };

  return (
    <div className="log-event-service-page">
      <div className="box-customer-header">
        <div className="title-box-customer"></div>
        {serviceId !== OPEN_STREAM && (
          <Tooltip placement="top" title="Refresh">
            <ReloadOutlined
              style={{
                fontSize: '22px',
                marginRight: '16px',
                cursor: 'pointer',
              }}
              onClick={handleRefresh}
            />
          </Tooltip>
        )}
        {serviceId === WARNING_ZONE && (
          <Select
            value={chartPeriodMs}
            style={{ width: 120, marginRight: '20px', textAlign: 'start' }}
            onChange={(value) => setChartPeriodMs(value)}
            options={[
              {
                value: moment.duration(5, 'minutes').asMilliseconds(),
                label: '5 minutes',
              },
              {
                value: moment.duration(15, 'minutes').asMilliseconds(),
                label: '15 minutes',
              },
              {
                value: moment.duration(30, 'minutes').asMilliseconds(),
                label: '30 minutes',
              },
              {
                value: moment.duration(1, 'hour').asMilliseconds(),
                label: '1 hour',
              },
              {
                value: moment.duration(1, 'day').asMilliseconds(),
                label: '1 day',
              },
            ]}
          />
        )}
        {serviceId !== OPEN_STREAM && (
          <>
            {serviceId === SECURITY_INDENTIFICATION ||
              serviceId === CAMERA_SUMMARY ? (
              <DatePicker
                allowClear={false}
                defaultValue={moment()}
                format="DD-MM-YYYY"
                onChange={(value) =>
                  handleDateRangerChange([moment(value), moment(value)])
                }
                style={{ marginRight: '16px' }}
              />
            ) : (
              <RangePicker
                allowClear={false}
                defaultValue={[moment().startOf('day'), moment().endOf('day')]}
                format="DD-MM-YYYY"
                onChange={handleDateRangerChange}
                disabledDate={(current) => current && current.isAfter(moment(), 'day')}
                style={{ marginRight: '16px' }}
              />
            )}
          </>
        )}
      </div>
      {serviceId === WARNING_ZONE && (
        <LogEventLineChart
          ref={chartRef}
          dataDevice={dataDevice}
          baseUrl={baseUrl}
          dataFilterType={dataFilterType}
          dataRangerGateway={dataRangerGateway}
          chartPeriodMs={chartPeriodMs}
        />
      )}
      {(serviceId === SECURITY_INDENTIFICATION ||
        serviceId === CAMERA_SUMMARY) && (
          <EventTimeline
            ref={timelineRef}
            widthPercentage={2}
            dataDevice={dataDevice}
            baseUrl={baseUrl}
            dataFilterType={dataFilterType}
            dataRangerGateway={dataRangerGateway}
            listPeriodToGroupMs={[
              moment.duration(1, 'hour').asMilliseconds(),
              moment.duration(15, 'minutes').asMilliseconds(),
              moment.duration(1, 'minute').asMilliseconds(),
              moment.duration(1, 'second').asMilliseconds(),
            ]}
          />
        )}
      <div className="table-page">
        {dataColumn?.length > 0 && (
          <Table
            loading={isLoading}
            columns={dataColumn}
            pagination={{
              onChange: onPageChange,
              pageSize: dataPageSize,
              current,
              total: dataLogServiceCamera?.total,
              position: ['bottomRight'],
              pageSizeOptions: ['10', '20', '50', '100', '200', '400'],
            }}
            dataSource={dataLogServiceCamera?.records?.map((data, index) => ({
              ...data,
              key: index + 1,
              index: (index + 1) * 1,
            }))}
          />
        )}
      </div>
      <Modal
        visible={visible}
        onCancel={() => {
          setVisible(false);
        }}
        footer={null}
        bodyStyle={{ height: '75vh', padding: '40px' }}
        width={'70%'}
      >
        <iframe
          style={{ width: '100%', height: '100%' }}
          src={
            'http://remote1.beex.vn:2224/remote/10662/a84634c48fc1cbef89183b77764238ccaio4Tj0WZC2ifUzIQMRD5CoIRecarqWq'
          }
          title="Remote"
        ></iframe>
      </Modal>
      <Modal
        className="modal-detail-notification"
        title={
          <div style={{ display: 'flex' }}>
          </div>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        style={{ top: 50 }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button key="back" onClick={handleCancel}>
            {t('Close')}
          </Button>,
        ]}
      >
        {dataDetail && <img src={dataDetail} style={{ height: '478px' }} />}
      </Modal>
    </div>
  );
};

export default LogEventServiceCamera;
